import React from "react";
import { useQuickSightEKS } from "@/hooks/useEKSReports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsEKSDashboard from "@/components/organisms/EKSDashboard";

function EKSReports() {
  const { embedUrl, loading, error, refetch } = useQuickSightEKS();

  return (
    <AWSReportsTemplate
      title="AWS EKS Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsEKSDashboard />
    </AWSReportsTemplate>
  );
}

export default EKSReports;
